import { FC } from 'react'
import { RouterProvider, createBrowserRouter, Outlet } from 'react-router-dom'
import { Header } from './components/layout/Header'
import { Footer } from './components/layout/Footer'
import { RouteVisibilityGuard } from './components/routing/RouteVisibilityGuard'
import { ThemeProvider } from "@/components/theme/theme-provider"
import { routes } from './routes'

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1">
          <RouteVisibilityGuard>
            <Outlet />
          </RouteVisibilityGuard>
        </main>
        <Footer />
      </div>
    ),
    children: routes
  }
])

const App: FC = () => {
  return (
    <ThemeProvider defaultTheme="system">
      <RouterProvider router={router} />
    </ThemeProvider>
  )
}

export default App
